export default __webpack_public_path__ + "static/media/eox-core.5dfdb56d.png";